import { CButton, CCol, CLabel, CRow, CInput } from "@coreui/react";
import { useState } from "react";
import { apiCallResponse, apiDownloadDocument } from "src/_apiConfig/apiCall";
import { addToastError, addToastSuccess } from "src/_constants/alert.type";
import Auth from "src/auth";
import ConfirmationPopup from "src/views/common/ConfirmationPopup";
import CustomeModalPopup from "src/views/common/CustomeModalPopup";

const LotListViewABS = (props) => {
  const { authenticated } = Auth();

  const [ABS_BGSelectedFile, setABS_BGSelectedFile] = useState();
  const [ABS_BGFileEvent, setABS_BGFileEvent] = useState(false);

  const [ABS_LotId, setABS_LotId] = useState();
  const [ABS_LotNo, setABS_LotNo] = useState();
  const [ABS_BGID, setABS_BGID] = useState();
  const [ABS_BGDueDate, setABS_BGDueDate] = useState();
  const [ABS_BGFilePath, setABS_BGFilePath] = useState();
  const [ABS_BGAmount, setABS_BGAmount] = useState();
  const [ABS_BGPaymentSlotId, setABS_BGPaymentSlotId] = useState();
  const [ABS_BGPaymentId, setABS_BGPaymentId] = useState();
  const [ABS_AMT, setABS_AMT] = useState();
  //const [openABSBGDetails, setOpenABSBGDetails] = useState(false);

  const [ABSBGPaymentOpen, setABSBGPaymentOpen] = useState();
  const [ABSPaymentConfirmationOpen, setABSPaymentConfirmationOpen] =
    useState();
  const [ABSPaymentLotId, setABSPaymentLotId] = useState();
  const [ABSPaymentActivityType, setABSPaymentActivityType] = useState();

  const handleABSPaymentOptionChange_Select = (
    lotpaymentid,
    abspaymentactivitytype
  ) => {
    setABSPaymentLotId(lotpaymentid);
    setABSPaymentActivityType(abspaymentactivitytype);
    setABSPaymentConfirmationOpen(true);
  };
  const handleOpenABSBGPaymentPopup = (
    lotid,
    lotno,
    BGID,
    BGDueDate,
    BGFilePath,
    BGAmount,
    BGPaymentId,
    BGPaymentSlotId,
    ABSAmt
  ) => {
    setABSBGPaymentOpen(true);
    setABS_LotId(lotid);
    setABS_LotNo(lotno);
    setABS_BGID(BGID);
    setABS_BGDueDate(BGDueDate);
    setABS_BGFilePath(BGFilePath);
    setABS_BGAmount(BGAmount);
    setABS_BGPaymentSlotId(BGPaymentSlotId);
    setABS_BGPaymentId(BGPaymentId);
    setABS_AMT(ABSAmt);
  };
  const handleABSPaymentOptionConfirmationClose = () =>
    setABSPaymentConfirmationOpen(false);
  const handleABSBGPaymentClose = () => setABSBGPaymentOpen(false);

  const submitCloseEvent = () => {
    setABSBGPaymentOpen(false);
    setABS_LotId(0);
    setABS_LotNo("");
    setABS_BGID(0);
    setABS_BGDueDate("");
    setABS_BGFilePath("");
    setABS_BGAmount("");
    setABS_BGPaymentSlotId("");
    setABS_BGPaymentId("");
    setABS_AMT("");
  };
  const HandlerABSBGDetailsSubmit = async (e) => {
    e.preventDefault();
    let fileEvent = ABS_BGFileEvent;
    if (ABS_BGSelectedFile === null || ABS_BGSelectedFile === undefined) {
      addToastError(
        props.setToasts,
        "Please upload Access Benefit Sharing Bank Guarantee document"
      );
      //alert("Please upload Access Benefit Sharing Bank Guarantee document");
    } else if (
      fileEvent !== false &&
      fileEvent.target.files[0].type !== "application/pdf"
    ) {
      addToastError(props.setToasts, "Please Upload Only pdf file!", 10000);
    } else if (ABS_BGAmount < ABS_AMT) {
      addToastError(
        props.setToasts,
        "BG Amount can not be less than payable ABS Amount.",
        0
      );
      //alert("BG Amount can not be less than payable ABS Amount.");
    } else {
      // let file = ABS_BGSelectedFile;
      // let filename = "";
      // if (file != null && file !== undefined) {
      //   filename = file.name;
      // }

      const header = new Headers();
      header.append("Content-Type", "application/json");

      const url = "LotDetails/UpdateABSBGPaymentDetails";
      const data = JSON.stringify({
        LotId: props.decrypted,
        BGAmount: ABS_BGAmount,
        BGDueDate: ABS_BGDueDate,
        BGID: ABS_BGID,
        UserId: Number(authenticated.userId),

        TenderPaymentSlotId: Number(ABS_BGPaymentSlotId),
      });
      await apiCallResponse(url, "POST", header, data).then((res) => {
        if (res.success) {
          //alert("BG Details Submit Successfully");
          let etaxfileevent = ABS_BGFileEvent;
          if (etaxfileevent !== false) {
            SaveABSBGDoc(ABS_LotId);
          } else {
            addToastSuccess(props.setToasts, "BG Details Submit Successfully");
            submitCloseEvent();
            //window.location.reload();
          }
        }
      });
    }
  };
  const SaveABSBGDoc = async (BGID) => {
    let fileEvent = ABS_BGFileEvent;
    let file = ABS_BGSelectedFile;
    if (fileEvent !== false) {
      if (authenticated) {
        if (fileEvent.target.files[0].type === "application/pdf") {
          // setSelectedFile(e.target.files[0]);
          //const files = fileEvent.target.files[0];
          const formData = new FormData();
          const header = new Headers();
          header.append("Accept", "application/json");

          formData.append("file", file);
          const url = `LotDetails/UploadABSBGCertificate/${ABS_LotId}`;
          await apiCallResponse(url, "POST", header, formData).then((res) => {
            if (res.success) {
              // alert("Document Uploaded Successfully!");
              setABS_BGSelectedFile();
              setABS_BGFileEvent(false);
              //window.location.reload();
              addToastSuccess(
                props.setToasts,
                "BG Details Submit Successfully"
              );
              submitCloseEvent();
              //handleABSPaymentOptionConfirmationClose();
              props.getLotDetails();
            } else {
              addToastError(props.setToasts, "Error to upload file!");
              //alert("Error to upload file!");
            }
          });
        } else {
          addToastError(props.setToasts, "Please Upload Only pdf file!");
          //alert("Please Upload Only pdf file!");
        }
      }
    }
  };

  const ABSConfirmationPOPUpSubmit = async (e) => {
    if (ABSPaymentActivityType === 1) {
      HandlerABSBGPaymentOptionChange();
    } else if (ABSPaymentActivityType === 2) {
      UpdateABSPaymentOption(ABSPaymentLotId);
    }
  };
  const HandlerABSBGPaymentOptionChange = async (e) => {
    const header = new Headers();
    header.append("Content-Type", "application/json");

    const url = "LotDetails/ABSPaymentOptionChangeRequest";
    const data = JSON.stringify({
      LotPaymentId: ABSPaymentLotId,
    });

    await apiCallResponse(url, "POST", header, data).then((res) => {
      if (res.success) {
        addToastSuccess(props.setToasts, "Payment Option Change Successfully");
        handleABSPaymentOptionConfirmationClose();
        props.getLotDetails();
      }
    });
  };
  const handleDownloadABSBGDocument = async (lotid, paymentId) => {
    const documentName = lotid + "_" + paymentId + ".pdf";
    const url = `LotDetails/DownloadABSBGCertificate?lotid=${Number(
      lotid
    )}&paymentid=${Number(paymentId)}`;

    await apiDownloadDocument(documentName, url).then((res) => {
      if (!res.success) alert(res.message);
    });
  };

  const UpdateABSPaymentOption = async (lotpaymentid) => {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const url = "LotDetails/UpdateABSPaymentOption";
    const data = JSON.stringify({
      LotPaymentId: Number(lotpaymentid),
      IsOnlinePayment: true,
    });
    await apiCallResponse(url, "POST", header, data).then((res) => {
      if (res.success) {
        addToastSuccess(props.setToasts, "Payment Option Updated Successfully");
        //alert("Payment Option Updated Successfully");
        handleABSPaymentOptionConfirmationClose();
        props.getLotDetails();
      } else {
        addToastError(props.setToasts, "Error Occured");
      }
    });
  };
  return (
    <>
      {props.viewListDetails.actualQuantity > 0 &&
        props.EmdPaid.isSignedByCFO === true &&
        !props.viewListDetails.isRequiredToReturnAdjustmentAmt && (
          <>
            <CRow className="pt-3" xl={12}>
              <CCol xl={12}>
                <h3>Pay Access Benefit Sharing</h3>
              </CCol>
            </CRow>
            <hr />
            <CRow className="pt-1" xl={12}>
              <CCol xl={12}>
                <h6>
                  Note: Payment option will be visible after selection of Access
                  Benefit sharing option
                  {/* <br />
                  {props.EmdPaid.isEMDPaid === true ? 1 : 0}
                  <br />
                  {props.viewListDetails.isAgreementAccepted === 1 ? 1 : 0}
                  <br />
                  {props.viewTenderDetails.isAgreementLetterGenerated === true
                    ? 1
                    : 0}
                  <br />
                  {props.viewListDetails.tenderType} */}
                </h6>
              </CCol>
            </CRow>
          </>
        )}

      {authenticated.role !== "Bidder" &&
        ((props.EmdPaid.isEMDPaid === true &&
          props.viewListDetails.isAgreementAccepted === 1) ||
          props.viewListDetails.tenderType === 2 ||
          props.viewListDetails.tenderType === 3) &&
        props.viewTenderDetails.isAgreementLetterGenerated &&
        props.EmdPaid.isSignedByCFO === true &&
        props.viewListDetails.actualQuantity > 0 &&
        !props.viewListDetails.isRequiredToReturnAdjustmentAmt && (
          <CRow className="mb-3">
            <CCol xl={12}>
              <CLabel className="mt-2 ml-1" style={{ fontWeight: "800" }}>
                Access Benefit Sharing Amount:{" "}
                {props.ABSPaymentDetails.accessBenefitSharingAmount}{" "}
                {props.ABSPaymentDetails.status}
              </CLabel>
            </CCol>
          </CRow>
        )}
      {authenticated.role === "Bidder" &&
        props.viewListDetails.status !== "Terminated" &&
        ((props.EmdPaid.isEMDPaid === true &&
          props.viewListDetails.isAgreementAccepted === 1) ||
          props.viewListDetails.tenderType === 2 ||
          props.viewListDetails.tenderType === 3) &&
        props.viewTenderDetails.isAgreementLetterGenerated &&
        props.EmdPaid.isSignedByCFO === true &&
        props.viewListDetails.actualQuantity > 0 &&
        !props.viewListDetails.isRequiredToReturnAdjustmentAmt && (
          <>
            <CRow className="mb-3">
              <CCol xl={12}>
                <CLabel className="mt-2 " style={{ fontWeight: "800" }}>
                  Access Benefit Sharing Amount:{" "}
                  {props.ABSPaymentDetails.accessBenefitSharingAmount}{" "}
                  {props.ABSPaymentDetails.status}
                </CLabel>
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol xl={12}>
                {!props.ABSPaymentDetails.hideOnlinePaymentOption && (
                  <CButton
                    color="success"
                    variant="outline"
                    className="mr-2 mb-2 width-15rem"
                    //hidden={props.ABSPaymentDetails.hideOnlinePaymentOption}
                    disabled={
                      props.ABSPaymentDetails.disableOnlinePaymentOption
                    }
                    onClick={() =>
                      handleABSPaymentOptionChange_Select(
                        props.ABSPaymentDetails.lotPaymentId,
                        2
                      )
                    }
                  >
                    Pay Access Benefit Sharing Amount Online
                  </CButton>
                )}
                {!props.ABSPaymentDetails.hideBGPaymentOption && (
                  <CButton
                    className="mr-2 mb-2 width-15rem"
                    color="success"
                    // hidden={props.ABSPaymentDetails.hideBGPaymentOption}
                    disabled={props.ABSPaymentDetails.disableBGPaymentOption}
                    onClick={() =>
                      handleOpenABSBGPaymentPopup(
                        props.viewListDetails.lotId,
                        props.viewListDetails.lotNo,
                        props.ABSPaymentDetails.bgid,
                        props.ABSPaymentDetails.bgDueDate,
                        props.ABSPaymentDetails.bgFilePath,
                        props.ABSPaymentDetails.bgAmount,
                        props.ABSPaymentDetails.abS_BGPaymentId,
                        props.ABSPaymentDetails.tenderPaymentSlotId,
                        props.ABSPaymentDetails.accessBenefitSharingAmount
                      )
                    }
                  >
                    Pay Access Benefit Sharing Amount via Bank Guarantee
                  </CButton>
                )}

                {/* {!props.ABSPaymentDetails.hideChangeOption && ( */}
                <CButton
                  color="info"
                  className="mr-2 ml-2 mb-2 width-15rem"
                  hidden={props.ABSPaymentDetails.hideChangeOption}
                  style={{ height: "3.45rem" }}
                  disabled={props.ABSPaymentDetails.disableChangeOption}
                  onClick={() =>
                    handleABSPaymentOptionChange_Select(
                      props.ABSPaymentDetails.lotPaymentId,
                      1
                    )
                  }
                >
                  Change ABS Payment Option
                </CButton>
                {/* )} */}
              </CCol>
            </CRow>
          </>
        )}
      <ConfirmationPopup
        showModal={ABSPaymentConfirmationOpen}
        hideModal={handleABSPaymentOptionConfirmationClose}
        confirmModal={ABSConfirmationPOPUpSubmit}
        id={props.CPopUpId}
        index={props.CPopUpIndex}
        ModalBody={
          ABSPaymentActivityType === 1
            ? " Are you sure you want to change ABS Payment option?"
            : ABSPaymentActivityType === 2
            ? "Are you sure you want to pay ABS Payment online?"
            : ABSPaymentActivityType === 3
            ? "Are you sure you want to pay ABS Payment via Bank Guarantee"
            : ""
        }
        //ModalTitle={CPopUpTitle}
        confirmButtonCss="btn btn-danger"
        ButtonLoader={false}
      />
      <CustomeModalPopup
        onOpen={ABSBGPaymentOpen}
        onClose={handleABSBGPaymentClose}
        onSubmitButton={HandlerABSBGDetailsSubmit}
        onCloseButton={handleABSBGPaymentClose}
        popupWith={450}
        body={
          <>
            <CRow>
              <CCol>
                <CLabel>LotNo: {ABS_LotNo}</CLabel>
              </CCol>
            </CRow>

            <hr />
            <CRow className="mb-3">
              <CCol>
                <CLabel>BGID</CLabel>
                <CInput
                  required
                  maxLength={45}
                  value={ABS_BGID}
                  onChange={(e) => {
                    setABS_BGID(e.target.value);
                  }}
                  id="absbgid"
                  invalid={ABS_BGID === "" ? true : false}
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol>
                <CLabel>BG Amount</CLabel>
                <CInput
                  required
                  value={ABS_BGAmount}
                  onChange={(e) => {
                    setABS_BGAmount(e.target.value);
                  }}
                  id="bgamt"
                  step="any"
                  presicion={2}
                  type="number"
                  invalid={ABS_BGAmount === "" ? true : false}
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CLabel>BG Due Date :</CLabel>
                <CInput
                  type="date"
                  required
                  placeholder=""
                  onChange={(e) => {
                    setABS_BGDueDate(e.target.value);
                    e.preventDefault();
                  }}
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol className="mt-4">
                <CLabel>Upload Document</CLabel>
                <input
                  name="file"
                  id="absbgfile"
                  type="file"
                  accept=".pdf"
                  style={{ display: "inline", marginLeft: "20px" }}
                  onChange={(e) => {
                    setABS_BGFileEvent(e);
                    setABS_BGSelectedFile(e.target.files[0]);
                    e.preventDefault();
                  }}
                />
              </CCol>
            </CRow>
          </>
        }
        footerBeforeBtn={
          ABS_BGFilePath !== null &&
          ABS_BGFilePath !== "" && (
            <CButton
              className="mt-1 mr-2"
              color="success"
              onClick={() =>
                handleDownloadABSBGDocument(ABS_LotId, ABS_BGPaymentId)
              }
            >
              Download Document
            </CButton>
          )
        }
        isFromSubmit={true}
        isSubmitBtnDisabled={true}
        ButtonLoader={false}
        //disabledBtn={isPaidActualGodownRent}
        btnSubmitText={"Submit"}
        btnCloseText={"Close"}
        btnCColstyle={{ textAlign: "right" }}
      />
    </>
  );
};

export default LotListViewABS;
